<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: jml
 * @LastEditTime: 2020-12-28 10:13:59
-->
<template>
  <div class="custom-pie">
    <div class="custom-pie-item">
      <svg class="svg" width="500" height="360" viewport="0 0 400 360">
        <g class="svg-content">
          <ellipse
            class="shodow"
            :cx="90"
            :cy="30"
            :rx="90"
            :ry="30"
            fill="#EBEEF8"
          />
          <g
            v-for="(item, index) in pathArr"
            :key="index"
            @mouseenter="$set(pathHover, index, true)"
            @mouseleave="$set(pathHover, index, false)"
          >
            <path
              class="custom-pie-item-block"
              v-for="(v, k) in item.surfaces"
              :key="k"
              :d="v"
              :fill="
                colorArr[item.index % 6](
                  (k == 'top' ? 1 : k == 'back' ? 0.8 : 0.6) -
                    (pathHover[index] ? 0.1 : 0)
                )
              "
              stroke="red"
              stroke-width="0"
              :data-v="v"
              :data-k="k"
            />
            <pieLineText
              :series0data="dealSeries0data"
              :pointPath="item.point.path"
              :point="item.point.o"
              :label="
                `${item.info.name}${item.info.b ? '：' + item.info.b : ''}`
              "
              :a="a"
              :b="b"
              :index="item.index"
              :icon="colorArr[item.index % 6](1)"
            />
          </g>
        </g>
      </svg>
    </div>
    <Table :table="table" :normalTable="table && table.isNormal"></Table>
  </div>
</template>

<script>
import { colorArr, colorMixOpacity } from '../color/config.js';
import { getPie } from './common/tools.js';
import Table from '../Table';
import pieLineText from './pieLineText.vue';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  components: { Table, pieLineText },
  data() {
    return {
      colorArr,
      colorMixOpacity,
      pathArr: [],
      pathHover: [],
      a: 80, // 长轴
      b: 60 // 短轴
    };
  },
  methods: {},
  computed: {
    dealSeries0data() {
      return this.series0data.filter(i => i.value > 0);
    }
  },
  created() {
    const { a, b } = this;
    this.pathArr = getPie({
      data: this.dealSeries0data,
      axis: [a, b],
      miniAxis: [a - 20, b - 20],
      pyDis: 5,
      height: a == b ? 0 : 8,
      heightDis: a == b ? 0 : 3
    });
  }
};
</script>

<style lang="scss" scoped>
.custom-pie {
  display: flex;
  justify-content: space-around;
  align-items: center;
  &-item {
    .p {
      transform: translateY(-10px);
      &-1 {
        font-size: 14px;
        color: #434343;
        line-height: 1;
      }
      &-2 {
        font-size: 24px;
        color: #434343;
        line-height: 1;
        margin-top: 22px;
      }
    }
  }
}
.svg {
  path {
    transition: all 0.3s;
  }
  &-content {
    transform: translate(80px, 130px);
    .custom-pie-item-block {
      cursor: pointer;
    }
    .shodow {
      transform-origin: 120px 55px;
      transform: translateX(-10px) translateY(90px);
    }
  }
}
</style>
